import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme: any) => ({
  buttonColor: {
    color: "#1CABE2 !important",
  },
});

const ConfirmDialog = (props: any) => {
  const { classes } = props;

  return (
    <div>
      <Dialog open={props.open} onClose={props.close}>
        <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.close}
            color="primary"
            className={classes.buttonColor}
          >
            CANCEL
          </Button>
          <Button
            onClick={props.ok}
            color="primary"
            autoFocus={true}
            className={classes.buttonColor}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(ConfirmDialog);
